import { isElement } from './isElement';

// equivalent of closest function from Element interface
export const closestNode = (node: Node, selector: string) => {
  for (let n = node; n.parentNode; n = n.parentNode) {
    if (isElement(n) && n.matches(selector)) {
      return n;
    }
  }
  return null;
};
